import {v4 as uuidv4} from 'uuid';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ClientId, FromServerId, NLOId, NLOToServerId} from 'notebook/ELNConstants';
import {CidIdMap} from 'notebook/notes/NoteConstants';
import getNoteLinkedObjectsOfTypes from 'notebook/notes/util/getNoteLinkedObjectsOfTypes';
import {addCid} from 'notebook/store/StoreTransformUtil';
import {Note, NoteLinkedObjectType, NotePart} from 'notebook/util/NoteUtilConstants';
import uniqueId from 'util/uniqueId';

export type GenericNoteLinkedAppCanvas<TIds> = {
  name: string;
  type: NoteLinkedObjectType.NOTE_LINKED_APP_CANVAS;
  appInstallationApiId: string;
  featureDeveloperDefinedId: string;
  provenanceUuid: string;
  canvasApiId?: string;
} & NLOId<TIds>;

export type NoteLinkedAppCanvas = GenericNoteLinkedAppCanvas<ClientId>;
export type FromServerNoteLinkedAppCanvas = GenericNoteLinkedAppCanvas<FromServerId>;
export type AppCanvasNotePart = NotePart & {item: NoteLinkedAppCanvas};

const cidPrefix = 'note-linked-app-canvas-';

export function createEmptyNoteLinkedAppCanvas(
  appInstallationApiId: string,
  featureDeveloperDefinedId: string
): NoteLinkedAppCanvas {
  return {
    type: NoteLinkedObjectType.NOTE_LINKED_APP_CANVAS,
    cid: uniqueId(cidPrefix),
    provenanceUuid: uuidv4(),
    featureDeveloperDefinedId,
    appInstallationApiId,
    name: '',
  };
}

export function prepareForStore(item: FromServerNoteLinkedAppCanvas, cidIdMap: CidIdMap): void {
  addCid(item, cidPrefix, cidIdMap);
}

export function prepareForSave(
  item: NoteLinkedAppCanvas,
  cidIdMap: CidIdMap
): GenericNoteLinkedAppCanvas<NLOToServerId> {
  return {
    ...item,
    id: cidIdMap[item.cid] as string,
  };
}

export function getNoteLinkedAppCanvasesInNote(note: Note): Array<NoteLinkedAppCanvas> {
  return getNoteLinkedObjectsOfTypes(note, [
    ModelTypeConstants.NOTE_LINKED_APP_CANVAS,
  ]) as Array<NoteLinkedAppCanvas>;
}
